export const MESSAGE_LIST_WIDGET_LIMIT = 1e3;
